<template>
  <b-modal :active.sync="show" :width="500">
    <div class="card">
      <div class="card-header">
        <h3 class="card-header-title">Delete Transaction</h3>
      </div>
      <div class="card-content">
        Are you sure you want to delete transaction {{ transactionId  }}?
      </div>
      <div class="card-footer">
        <div class="card-footer-item is-danger">
          <button type="button"
                  class="button"
                  :disabled="isDeleting"
                  @click="toggle">
            Cancel
          </button>
        </div>
        <div class="card-footer-item" >
          <button type="button"
                  class="button is-danger"
                  :class="{ 'is-loading': isDeleting }"
                  :disabled="isDeleting"
                  @click="confirmDelete">
            Delete
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TransactionDeleteConfirmationModal',
  props: {
    show: {
      required: true,
      type: Boolean
    },
    companyJob: {
      required: true,
      type: Object
    }
  },

  computed: {
    transactionId() {
      let transactionId = this.companyJob.companyJobId
      if (!transactionId) {
        transactionId = this.companyJob.basicInfo.companyJobId
      }

      return transactionId
    }
  },

  data() {
    return {
      isDeleting: false
    }
  },

  methods: {
    toggle() {
      this.$emit('update:show', false)
    },
    confirmDelete() {
      this.isDeleting = true
      this.$emit('deleteConfirmed', this.companyJob)
    }
  }
}
</script>

<style scoped>
</style>
